import { gql } from "@apollo/client";

export const FETCH_ALL_COMMERCIAL_USERS = gql`
  query FetchAllCommercialUsers($limit:Int, $offset:Int) {
    fetchAllCommercialUsers(limit:$limit, offset:$offset) {
      error {
            message
            code
            field
        }
        data {
            users {
                mobile_no
                status
                created_at
                updated_at
                id
                user_identifier
                email
                user_profile {
                    gender
                    created_at
                    updated_at
                    id
                    name
                    profile_picture
                }
            }
        }
    }
  }
`;

export const FETCH_ALL_COMMERCIAL_ACTIVE_USERS = gql`
  query GetUserActivity($limit:Int, $offset:Int) {
    getUserActivity(limit:$limit, offset:$offset) {
      data {
            grouped_user_activities {
                user_id
                month
                year
                total_count
                activity_counts {
                    video_watched
                    others
                    CheyChey
                }
                user {
                    id
                    user_identifier
                    email
                    mobile_no
                    status
                    created_at
                    updated_at
                    user_profile {
                        name
                        profile_picture
                        gender
                        created_at
                        updated_at
                        id
                    }
                }
            }
        }
        error {
            message
            code
            field
        }
    }
  }
`;

export const FETCH_COMMERCIAL_USER_BY_ID = gql`
  query FetchUser($user_id: UUID) {
    fetchUser(user_id: $user_id) {
      data {
        user {
          created_at
          email
          id
          mobile_no
          status
          updated_at
          user_identifier
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const CHECK_EXISTING_COMMERCIAL_USER = gql`
  query CheckForExistingCommercialUser($field: String, $value: String) {
    checkForExistingCommercialUser(field: $field, value: $value) {
      data {
        exist_user
        user_id
      }
      error {
        message
      }
    }
  }
`;

export const FETCH_COMMERCIAL_PROFILE_BY_USER_ID = gql`
  query FetchCommercialProfileByUserId($user_id: UUID) {
    fetchProfileByCommercialUserId(user_id: $user_id) {
      data {
        user_profile {
          created_at
          gender
          id
          name
          profile_picture
          updated_at
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const FETCH_COMMERCIAL_NEW_REGISTER = gql`
  query FetchCommercialNewRegister($from_date: Time, $to_date: Time) {
    fetchCommercialNewRegister(from_date: $from_date, to_date: $to_date) {
      data {
        users {
          created_at
          email
          id
          mobile_no
          status
          updated_at
          user_identifier
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;
